import { themed } from '@indeed/ifl-css';

const TouchTarget = /*#__PURE__*/themed("span", process.env.NODE_ENV === "production" ? {
  target: "ey2nhmw0"
} : {
  target: "ey2nhmw0",
  label: "TouchTarget"
})({
  position: "relative",
  "::after": {
    content: "''",
    position: "absolute",
    top: "50%",
    left: "50%",
    blockSize: "100%",
    inlineSize: "100%",
    minInlineSize: "44px",
    minBlockSize: "44px",
    transform: "translate(-50%, -50%)",
    zIndex: -1
  }
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlRvdWNoVGFyZ2V0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFMkIiLCJmaWxlIjoiVG91Y2hUYXJnZXQudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgdGhlbWVkLCBTdHlsZVByb3BzIH0gZnJvbSBcIkBpbmRlZWQvaWZsLWNzc1wiO1xuXG5leHBvcnQgY29uc3QgVG91Y2hUYXJnZXQgPSB0aGVtZWQoXCJzcGFuXCIpPFN0eWxlUHJvcHM+KHtcbiAgcG9zaXRpb246IFwicmVsYXRpdmVcIixcbiAgXCI6OmFmdGVyXCI6IHtcbiAgICBjb250ZW50OiBcIicnXCIsXG4gICAgcG9zaXRpb246IFwiYWJzb2x1dGVcIixcbiAgICB0b3A6IFwiNTAlXCIsXG4gICAgbGVmdDogXCI1MCVcIixcbiAgICBibG9ja1NpemU6IFwiMTAwJVwiLFxuICAgIGlubGluZVNpemU6IFwiMTAwJVwiLFxuICAgIG1pbklubGluZVNpemU6IFwiNDRweFwiLFxuICAgIG1pbkJsb2NrU2l6ZTogXCI0NHB4XCIsXG4gICAgdHJhbnNmb3JtOiBcInRyYW5zbGF0ZSgtNTAlLCAtNTAlKVwiLFxuICAgIHpJbmRleDogLTFcbiAgfVxufSk7XG5cblRvdWNoVGFyZ2V0LmRpc3BsYXlOYW1lID0gXCJUb3VjaFRhcmdldFwiO1xuIl19 */");
TouchTarget.displayName = "TouchTarget";

export { TouchTarget };
